export const CSS_TYPE_COLUMN_WIDTH = 'neb-table-small-width';
export const CSS_ICON_COLUMN_WIDTH = 'neb-table-icon-column';
export const CSS_MESSAGE_COLUMN_WIDTH = 'neb-table-large-width';
